export default __webpack_public_path__ + "static/retention-light-881dd3ba016680e04fff226bc37fba00.png";